module.exports = __webpack_public_path__ + "static/img/parnter.2f11918.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-500/parnter.jpg
// module id = B0MW
// module chunks = 1